import { atom } from 'jotai';

const hsCodePopAtom = atom<boolean>(false);
const hsCodeResultAtom = atom<string>('');

export { hsCodePopAtom, hsCodeResultAtom };